<template>
  <v-tooltip top>
    <v-btn fab dark small color="amber darken-2" slot="activator" @click="upload()">
      <v-icon>file_upload</v-icon>
    </v-btn>
    <span>Upload</span>
  </v-tooltip>
</template>

<script>
export default {
  methods: {
    upload() {
      this.$emit("upload");
    }
  }
};
</script>

<style>
</style>
